module.exports = __webpack_public_path__ + "static/media/6.bb0ef67b.jpg";